<template>
	<div class="address_wrap">
		<div class="mail_address_int">
			<span class="mail_address_text">{{ title }}</span>
			<div class="mail_address_box" id="bcc_address_box">
				<div class="attached_address" v-for="(value, index) in addressList" :key="index">
					<span>{{ value }}</span>
					<a href="javascript:void(0);" @click="deleteAddress(index)">address delete</a>
				</div>
			</div>
		</div>
		<div class="address_add_box">
			<label>
				<input type="search" class="tbl_int address_input" placeholder="Search address" v-model="address" />
			</label>
			<a href="javascript:void(0);" class="normal_bt" @click="addAddress">Add</a>
		</div>
	</div>
</template>
<script>
export default {
	name: 'AddressWrap',
	props: {
		type: {},
		addressList: {},
		title: {},
	},
	data() {
		return {
			address: '',
		};
	},
	methods: {
		deleteAddress(index) {
			this.$emit('click', this.type, index);
		},
		addAddress() {
			this.$emit('input', this.type, this.address);
			this.address = '';
		},
	},
};
</script>
